// src/services/notificationService.js
import { db } from "../firebase/config";
import {
  requestNotificationPermission,
  listenForMessages,
} from "../firebase/messaging";
import {
  doc,
  arrayRemove,
  setDoc,
  serverTimestamp,
  arrayUnion,
  updateDoc,
} from "firebase/firestore";
/**
 * Ask user for permission & get FCM token
 */
export const initNotificationService = async () => {
  try {
    const token = await requestNotificationPermission();
    if (token) {
      //   console.log("✅ FCM Token:", token);
      // TODO: Send token to your backend so you can send notifications later
    } else {
      console.warn("⚠️ Notification permission not granted");
    }
  } catch (error) {
    console.error("❌ Error getting FCM token:", error);
  }
};

/**
 * Start listening for incoming foreground messages
 */
export const subscribeToMessages = (onMessageReceived) => {
  try {
    listenForMessages((payload) => {
      console.log("📩 Notification received:", payload);
      if (onMessageReceived) {
        onMessageReceived(payload);
      }
    });
  } catch (error) {
    console.error("❌ Error listening for messages:", error);
  }
};

export const saveUserToken = async (user, token) => {
  if (!user?.uuid || !token) return;

  try {
    const userRef = doc(db, "users", user.uuid);

    await setDoc(
      userRef,
      {
        userId: user.id,
        uuid: user.uuid,
        email: user.email || "",
        name: user.fullName || "",
        role: user.role || "",
        fcmTokens: arrayUnion(token), // ✅ add token to array if not present
        createdAt: serverTimestamp(),
      },
      { merge: true }
    );
    localStorage.setItem("fcm_token", token); // store in localStorage for easy access

    //console.log("✅ FCM token added to Firestore for user:", user.uuid);
  } catch (error) {
    console.error("❌ Error saving FCM token:", error);
  }
};

/**
 * Remove FCM token from Firestore when user logs out.
 */
export const removeUserToken = async (user, token) => {
  console.log("Removing FCM token for user in services:", user);
  if (!user?.uuid || !token) return;

  try {
    const userRef = doc(db, "users", user.uuid);

    await updateDoc(userRef, {
      fcmTokens: arrayRemove(token), // ✅ remove only that token
    });

    console.log("🗑️ FCM token removed for user:", user.uuid);
  } catch (error) {
    console.error("❌ Error removing FCM token:", error);
  }
};
